import React from 'react';

const Products = () => (
    <section id="portfolio"  className="section-bg" >
      <div className="container">

        <header className="section-header">
          <h3 className="section-title">Samples on Display</h3>
        </header>

        <div className="row">
          {/* <div className="col-lg-12">
            <ul id="portfolio-flters">
              <li data-filter="*" className="filter-active">All</li>
              <li data-filter=".filter-app">App</li>
              <li data-filter=".filter-card">Card</li>
              <li data-filter=".filter-web">Web</li>
            </ul>
          </div> */}
        </div>

        <div className="row portfolio-container">

          <div className="col-lg-4 col-md-6 portfolio-item filter-app wow fadeInUp">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p1.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p1.jpg" data-lightbox="portfolio" data-title="App 1" className="link-preview" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
              <h4><a href="#">Roman Tile</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.1s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p2.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p2.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 3" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
              <h4><a href="#">Mandarin Tile</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-app wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p3.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p3.jpg" className="link-preview" data-lightbox="portfolio" data-title="App 2" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">Roman Tile</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-card wow fadeInUp">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p4.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p4.jpg" className="link-preview" data-lightbox="portfolio" data-title="Card 2" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">Box Profile</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.1s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p5.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p5.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 2" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">Glazed Tile</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-app wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p6.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p6.jpg" className="link-preview" data-lightbox="portfolio" data-title="App 3" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
              <h4><a href="#">Glazed Tile</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-card wow fadeInUp">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p7.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p7.jpg" className="link-preview" data-lightbox="portfolio" data-title="Card 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
              <h4><a href="#">Versatile roofing sheet</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-card wow fadeInUp" data-wow-delay="0.1s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p8.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p8.jpg" className="link-preview" data-lightbox="portfolio" data-title="Card 3" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
              <h4><a href="#">Roman Tile</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p9.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p9.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
              <h4><a href="#">Glazed Tile</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p10.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p10.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p11.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p11.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p12.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p12.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p13.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p13.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p14.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p14.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p15.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p15.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p16.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p16.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p17.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p17.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p18.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p18.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p19.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p19.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p20.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p20.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp" data-wow-delay="0.2s">
            <div className="portfolio-wrap">
              <figure>
                <img src="componentsScripts/img/portfolio/p21.jpg" className="img-fluid" alt=""/>
                <a href="componentsScripts/img/portfolio/p21.jpg" className="link-preview" data-lightbox="portfolio" data-title="Web 1" title="Preview"><i className="ion ion-eye"></i></a>
                <a href="#" className="link-details" title="More Details"><i className="ion ion-android-open"></i></a>
              </figure>

              <div className="portfolio-info">
                <h4><a href="#">sample</a></h4>
                <p>For more info. Call 0724758212</p>
              </div>
            </div>
          </div>

          </div>

        </div>
        

    
    </section>
);
export default Products;
